
class Validator {
  static required(value, rule) {
    if (value === 0) { // JavaScript treats x = 0 as !x but zero values are OK
      return false;
    }
    if (!value || value.length < 1) {
      return rule.msg
    }
    return false;
  }

  static minLength(value, rule) {
    if (value.length < rule.value) {
      return rule.msg;
    }
    return false;
  }

  static maxLength(value, rule) {
    if (value.length > rule.value) {
      return rule.msg;
    }
    return false;
  }

  static minVal(value, rule) {
    if (value < rule.value) {
      return rule.msg;
    }
    return false;
  }

  static numeric(value, rule) {
    if (Number.isNaN(value)) {
      return rule.msg;
    }
    return false;
  }

  static oneOf(value, rule) {
    if (rule.options.indexOf(value) === -1) {
      return rule.msg;
    }
    return false;
  }
}

export const validate = (value, rules) => {
  if (!rules) {
    return false;
  }
  for (const fn of Object.keys(rules)) {
    const result = Validator[fn](value, rules[fn]);
    if (result && result.length) {
      return result;
    }
  }
  return false;
};
